export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeDeliveryInfo: {
        noticeDeliveryAt: 1234567890123,
        serviceName: 'アイラ地域サポート',
        deliveryToKbn: 2,
        deliveryToDeviceSerial: 'DeviceSerial',
        deliveryStatus: 1,
        deliveryLocationCount: 0,
        openedLocationCount: 0,
        thumbupLocationCount: 0,
        deliverySpCount: 0,
        openedSpCount: 0,
        thumbupSpCount: 0
      },
      deliveryContents: {
        title: '地元の名産品について',
        body: 'xxxxx',
        attachments: [],
        soundFile: [],
        linkUrl: 'http://www.google.co.jp',
        question: 'xxxxx',
        answerOptions: [],
        keikaiLevel: 0
      },
      noticeSenderName: 'アイラ地域サポート',
      deliveryPlanKbn: 3,
      // immediateDelivery: {
      //   deliveryEndDt: '2020-06-05 10:30:00'
      // },
      // reservedDelivery: {
      //   deliveryStartDt: '2020-06-05 10:30:00',
      //   deliveryEndDt: '2020-06-15 10:30:00'
      // },
      repeatedDelivery: {
        deliveryPattern: 42,
        deliveryStartDt: '2020-06-05 10:30:00',
        deliveryEndDt: '2020-06-25 10:30:00'
      },
      noticeTypeMstUuid: 'noticeType001',
      deliveryTypeMstUuid: 'deliverytypemst001'
    }
  }
}